import { cva } from '@/styled-system/css';

export const tabsPanelRecipe = cva({
  base: {
    padding: 'Tabs.padding.panel',
    focusOutline: true,
  },
  variants: {
    appearance: {
      default: {
        backgroundColor: 'Tabs.default.bg.panel',
      },
      file: {
        backgroundColor: 'Tabs.file.bg.panel',
        borderStyle: 'solid',
        borderWidth: 'Tabs.default',
        borderColor: 'Tabs.file.border.default',
      },
    },
    selected: {
      true: {
        display: 'block',
      },
      false: {
        display: 'none',
      },
    },
    fluid: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      appearance: 'file',
      fluid: false,
      css: {
        borderStartEndRadius: 'Tabs.panel',
      },
    },
  ],
});
